export default {
  SET_AUDITS(state, audits) {
    state.audits = Array.isArray(audits) ? audits : []
  },
  SET_PAGINATION(state, pagination) {
    state.pagination = { ...state.pagination, ...pagination }
  },
  SET_STATS(state, stats) {
    state.stats = stats || null
  },
}
